import React from 'react';
import HTMLReactParser from 'html-react-parser';
import './footer.css';

const Footer = (props) => (
  <footer style={{ 
    backgroundColor: props.bgc, 
    backgroundImage:"url("+props.bgi+")", 
    padding: props.padding, 
    height: props.height, 
    minHeight: props.minHeight,
    maxHeight: props.maxHeight,
    maxWidth: props.maxWidth, 
    width: props.width, 
    ...props.styles 
  }}>
    {HTMLReactParser(props.children)}
  </footer>
);

Footer.defaultProps = {
  maxWidth:"100%",
  width:"100%",
  bgc:"#007155",
  bgi: "none",
  styles: {
    color: "#fff",
    fontSize: "16px",
    fontFamily: "Roboto, sans-serif",
    textTransform: "none",
    lineHeight: "16px",
    border: "0px dashed #cc00cc",
    verticalAlign:"middle",
    textAlign:"center",
    clear:"both",
    position:"relative",
    padding:"3px",
  },
  children: "The University of Vermont",
}

export default Footer;
